import { ArrowUpRight, CalendarPlus } from 'lucide-react';
import { Link } from 'react-router-dom';

export function DepartmentCard({ item }) {
  const Icon = item.icon;
  const slug = item.name.toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
  return <article className="department-card"><span className="card-icon"><Icon/></span><h3>{item.name}</h3><p>{item.text}</p><Link to={`/specialties/${slug}`}>Explore specialty <ArrowUpRight size={17}/></Link></article>;
}

export function DoctorCard({ doctor }) {
  return <article className="doctor-card"><div className="doctor-image"><img src={doctor.image} alt={doctor.name} loading="lazy"/><span>Available this week</span></div><div className="doctor-copy"><small>{doctor.role}</small><h3>{doctor.name}</h3><p>{doctor.exp} experience</p><Link to="/appointment"><CalendarPlus size={17}/> Book consultation</Link></div></article>;
}
